import { useEffect, useState, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export default function RequireAdmin({ children }: { children: ReactNode }) {
  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    supabase.auth.getSession().then(({ data }) => {
      if (!data.session) {
        if (!cancelled) {
          setIsAdmin(false);
          setChecking(false);
        }
        return;
      }

      supabase
        .rpc('is_admin_mgr')
        .then(({ data: adminData }) => {
          if (!cancelled) {
            setIsAdmin(!!adminData);
            setChecking(false);
          }
        })
        .catch(() => {
          if (!cancelled) {
            setIsAdmin(false);
            setChecking(false);
          }
        });
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="flex items-center gap-3 text-foreground-600">
          <i className="ri-loader-4-line text-2xl animate-spin text-primary-400" />
          <span className="text-sm">Đang tải...</span>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to={`/dang-nhap?next=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return <>{children}</>;
}